// extracted by mini-css-extract-plugin
export default {"container":"Logout_container__EBma5","text":"Logout_text__rzDP9"};